import { msg } from "@omegagrid/localize";
import { NodeSource, TreeOptions, TreeSource } from "@omegagrid/tree";
import { BrowserAdapter } from "@reporting/rp-app-host";

export class GeneralBrowserAdapter extends BrowserAdapter {

	constructor() { super() }

	async getTree(): Promise<TreeSource> {
		const treeItems: NodeSource[] = [];
		treeItems.push({
			k: 'definition-translations',
			v: msg('Translations'),
			icon: 'language', 
			l: 0,
			collapsed: true,
		}, {
			k: 'definition-styles-table',
			v: msg('Styles'),
			icon: 'image', 
			l: 0,
			collapsed: true,
		}, {
			k: 'definition-styles',
			v: `${msg('Styles')} (${msg('legacy')})`,
			icon: 'images',
			l: 0,
			collapsed: true,
		});
		return treeItems;
	}

	getOptions(): Partial<TreeOptions> {
		return {
			selectMode: 'none',
			expanders: false,
		};
	}
}
